import axios from 'axios'
const strapiAPI = axios.create({ baseURL: process.env.STRAPI_API_URL })
import { HeaderState } from 'src/core/models'

export type AvailableLocale = 'en' | 'es' | 'fr' | 'ko' | 'de' | 'it' | 'pt' | 'pl' | 'zh'

export const _fetchHeaderData = async (lang: string = 'en'): Promise<HeaderState> => {
  try {
    const { data }  = await strapiAPI.get(
      `${process.env.STRAPI_API_URL}/header?populate=deep,6&locale=${lang}`
    )
    return data?.data
  } catch(error) {
    console.error(`[_fetchHeaderData]`, error)
  }

}

export const getHeaderData = async (lang: string = 'en'): Promise<HeaderState> => {
  return await _fetchHeaderData(lang) || await _fetchHeaderData()
}
